import { useBreakpoints, useRequest, useView } from '@10000/react'
import { InputScreen, onboardBackground, useBackground, useShell, useStack } from '../../layout'
import { Avatar, Location, Text } from '../../forms'
import { Box } from '../../widgets'
import { TeamLevel } from './'
import { isPartner } from '../../../lookups'
import { randomInt } from '@10000/common'

export const TeamName = ({ active, id, organisationId }) => {
  const request = useRequest('tenant')
  const { teams, user: { admin }, subscription, organisations, company } = useView('tenant')
  const { push } = useStack()
  const { mobile } = useBreakpoints()

  const organisation = organisations.find(x => x.id === organisationId) || {}

  const {
    name,
    avatar = randomInt(6),
    country = organisation?.country || company?.country,
    city = organisation?.city || company?.city
  } = teams.find(x => x.id === id)

  useShell({
    active,
    mode: 'progress narrow',
    ...(admin ? isPartner(subscription) ? { step: 6, max: 8 } : { step: 4, max: 6 } : { step: 2, max: 4 })
  })
  useBackground().set(mobile => ({ active, fade: !admin, ...onboardBackground(admin, mobile) }))

  const handleTeamName = (values) => request('teamUpdated', { id, ...values })
    .then(() => push(TeamLevel, { props: { id, organisationId } }))

  return <InputScreen
    fade
    fadeColour={!admin && 'blue'}
    onSubmit={handleTeamName}
    formValues={{ avatar, name, country, city }}
    footerButton="Next"
    title="Name your team"
    description="Choose a name for this team that will distinguish it from your other teams"
  >
    <Box column gap={24}>
      <Avatar
        name="avatar"
        size={mobile ? 'medium' : 'large'}
        mode="team"
      />
      <Text name="name" title="Team name" required/>
      <Location country={country} />
    </Box>
  </InputScreen>
}